// extracted by mini-css-extract-plugin
export default {"thead":"CrossSectionPoints_thead__0Hd1t","tbody":"CrossSectionPoints_tbody__lC1Rf"};